import { useCallback, useEffect, useState } from 'react'
import type { AccountTransaction } from '@viilu-web/shared/types/account-transactions'
import type { AccountTransactionsQueryOptions } from './types'
import { _getAccountTransactions } from '../../../state/finance-account-transactions'

function useAccountTransactions(queryParams: AccountTransactionsQueryOptions) {
	const [transactions, setTransactionsResult] = useState<AccountTransaction[]>(
		[],
	)
	const [loadingTransactions, setLoadingTransactions] = useState<boolean>(false)
	const [errorTransactions, setErrorTransactions] = useState<string | null>(
		null,
	)

	const fetchTransactions = useCallback(async () => {
		const { managerUUID, companyUUID } = queryParams

		if (!managerUUID || !companyUUID) {
			setLoadingTransactions(false)
			return
		}

		setLoadingTransactions(true)
		setErrorTransactions(null)
		try {
			const response = await _getAccountTransactions(queryParams)
			if (response?.ok) {
				const resData = await response.json()
				if (resData.transactions && Array.isArray(resData.transactions)) {
					setTransactionsResult(resData.transactions)
				}
			} else {
				setErrorTransactions(`Failed to fetch transactions`)
			}
		} catch (error: any) {
			setErrorTransactions(error?.message || 'Failed to fetch transactions')
		} finally {
			setLoadingTransactions(false)
		}
	}, [queryParams])

	useEffect(() => {
		fetchTransactions()
	}, [fetchTransactions])

	return {
		transactions,
		loadingTransactions,
		errorTransactions,
		refreshTransactions: fetchTransactions,
	}
}

export default useAccountTransactions
